<template>
        <div>
          {{total_ytd}}
        </div>
			
</template>

  <script>
	  export default {
		  mounted() {
			 // console.log('Payslip started..');   
		  },
		  props: ['employee_id', 'fiscal_year', 'head', 'current_headvalue','month'],
				 
   
		  data() {
			  
			  return {
				  emp_id: this.employee_id,  
                  fyear: this.fiscal_year, 
                  cur_head: this.head, 
                  total_ytd:'loading..',
                  cur_headvalue:this.current_headvalue,
                  mnth:this.month,
			  }
		  },
		  
		  methods:{
		  

			  
			  getheadytd: function()
			  {
  
                  axios.get(this.$api_url+'/get-head-ytd/'+this.emp_id+'/'+this.fyear+'/'+this.cur_head+'/'+this.cur_headvalue+'/'+this.mnth , {
							  params: {
								  status: '',
							  }
					  }).then(function(response){
					  this.total_ytd =response.data.ytd;
  
  
				  }.bind(this));
			  },
              
              
              failed_request_recovery: function()
			  {
			       if(this.total_ytd=='loading..')
                   {
                   //alert(1);
                   this.getheadytd();
                   }
			  },
			  
  
		  },
		  created: function(){
		  
		     this.getheadytd();
             
             setInterval(this.failed_request_recovery, 4000);
             
             

			 	
		  }
	  }
  </script>